import { TeamInfo } from './types';

const TEAM_LOGO_BASE = 'https://awesemostorage.blob.core.windows.net/sports/nhl/teams';

export const nhlTeams: Record<string, TeamInfo> = {
  // Primary entries using common API abbreviations
  ANA: { name: 'Ducks', fullName: 'Anaheim Ducks', abbr: 'ANA', logo: `${TEAM_LOGO_BASE}/ANHD.png` },
  ARI: { name: 'Coyotes', fullName: 'Arizona Coyotes', abbr: 'ARI', logo: `${TEAM_LOGO_BASE}/ARIC.png` },
  BOS: { name: 'Bruins', fullName: 'Boston Bruins', abbr: 'BOS', logo: `${TEAM_LOGO_BASE}/BOSB.png` },
  BUF: { name: 'Sabres', fullName: 'Buffalo Sabres', abbr: 'BUF', logo: `${TEAM_LOGO_BASE}/BUFS.png` },
  CAR: { name: 'Hurricanes', fullName: 'Carolina Hurricanes', abbr: 'CAR', logo: `${TEAM_LOGO_BASE}/CARH.png` },
  CBJ: { name: 'Blue Jackets', fullName: 'Columbus Blue Jackets', abbr: 'CBJ', logo: `${TEAM_LOGO_BASE}/CBJB.png` },
  CGY: { name: 'Flames', fullName: 'Calgary Flames', abbr: 'CGY', logo: `${TEAM_LOGO_BASE}/CGYF.png` },
  CHI: { name: 'Blackhawks', fullName: 'Chicago Blackhawks', abbr: 'CHI', logo: `${TEAM_LOGO_BASE}/CHIB.png` },
  COL: { name: 'Avalanche', fullName: 'Colorado Avalanche', abbr: 'COL', logo: `${TEAM_LOGO_BASE}/COLA.png` },
  DAL: { name: 'Stars', fullName: 'Dallas Stars', abbr: 'DAL', logo: `${TEAM_LOGO_BASE}/DALS.png` },
  DET: { name: 'Red Wings', fullName: 'Detroit Red Wings', abbr: 'DET', logo: `${TEAM_LOGO_BASE}/DETR.png` },
  EDM: { name: 'Oilers', fullName: 'Edmonton Oilers', abbr: 'EDM', logo: `${TEAM_LOGO_BASE}/EDMO.png` },
  FLA: { name: 'Panthers', fullName: 'Florida Panthers', abbr: 'FLA', logo: `${TEAM_LOGO_BASE}/FLAP.png` },
  LA: { name: 'Kings', fullName: 'Los Angeles Kings', abbr: 'LA', logo: `${TEAM_LOGO_BASE}/LAK.png` },
  MIN: { name: 'Wild', fullName: 'Minnesota Wild', abbr: 'MIN', logo: `${TEAM_LOGO_BASE}/MINW.png` },
  MTL: { name: 'Canadiens', fullName: 'Montreal Canadiens', abbr: 'MTL', logo: `${TEAM_LOGO_BASE}/MONC.png` },
  NSH: { name: 'Predators', fullName: 'Nashville Predators', abbr: 'NSH', logo: `${TEAM_LOGO_BASE}/NSHP.png` },
  NJ: { name: 'Devils', fullName: 'New Jersey Devils', abbr: 'NJ', logo: `${TEAM_LOGO_BASE}/NJD.png` },
  NYI: { name: 'Islanders', fullName: 'New York Islanders', abbr: 'NYI', logo: `${TEAM_LOGO_BASE}/NYII.png` },
  NYR: { name: 'Rangers', fullName: 'New York Rangers', abbr: 'NYR', logo: `${TEAM_LOGO_BASE}/NYRR.png` },
  OTT: { name: 'Senators', fullName: 'Ottawa Senators', abbr: 'OTT', logo: `${TEAM_LOGO_BASE}/OTTS.png` },
  PHI: { name: 'Flyers', fullName: 'Philadelphia Flyers', abbr: 'PHI', logo: `${TEAM_LOGO_BASE}/PHIF.png` },
  PIT: { name: 'Penguins', fullName: 'Pittsburgh Penguins', abbr: 'PIT', logo: `${TEAM_LOGO_BASE}/PITP.png` },
  SEA: { name: 'Kraken', fullName: 'Seattle Kraken', abbr: 'SEA', logo: `${TEAM_LOGO_BASE}/SEAK.png` },
  SJ: { name: 'Sharks', fullName: 'San Jose Sharks', abbr: 'SJ', logo: `${TEAM_LOGO_BASE}/SJS.png` },
  STL: { name: 'Blues', fullName: 'St. Louis Blues', abbr: 'STL', logo: `${TEAM_LOGO_BASE}/STLB.png` },
  TB: { name: 'Lightning', fullName: 'Tampa Bay Lightning', abbr: 'TB', logo: `${TEAM_LOGO_BASE}/TBL.png` },
  TOR: { name: 'Maple Leafs', fullName: 'Toronto Maple Leafs', abbr: 'TOR', logo: `${TEAM_LOGO_BASE}/TORM.png` },
  UTA: { name: 'Utah HC', fullName: 'Utah Hockey Club', abbr: 'UTA', logo: `${TEAM_LOGO_BASE}/UTAM.png` },
  VAN: { name: 'Canucks', fullName: 'Vancouver Canucks', abbr: 'VAN', logo: `${TEAM_LOGO_BASE}/VANC.png` },
  VGK: { name: 'Golden Knights', fullName: 'Vegas Golden Knights', abbr: 'VGK', logo: `${TEAM_LOGO_BASE}/VGKG.png` },
  WSH: { name: 'Capitals', fullName: 'Washington Capitals', abbr: 'WSH', logo: `${TEAM_LOGO_BASE}/WASC.png` },
  WPG: { name: 'Jets', fullName: 'Winnipeg Jets', abbr: 'WPG', logo: `${TEAM_LOGO_BASE}/WPGJ.png` },
  // Aliases for alternative abbreviations
  ANH: { name: 'Ducks', fullName: 'Anaheim Ducks', abbr: 'ANA', logo: `${TEAM_LOGO_BASE}/ANHD.png` },
  LAK: { name: 'Kings', fullName: 'Los Angeles Kings', abbr: 'LA', logo: `${TEAM_LOGO_BASE}/LAK.png` },
  LOS: { name: 'Kings', fullName: 'Los Angeles Kings', abbr: 'LA', logo: `${TEAM_LOGO_BASE}/LAK.png` },
  MON: { name: 'Canadiens', fullName: 'Montreal Canadiens', abbr: 'MTL', logo: `${TEAM_LOGO_BASE}/MONC.png` },
  NAS: { name: 'Predators', fullName: 'Nashville Predators', abbr: 'NSH', logo: `${TEAM_LOGO_BASE}/NSHP.png` },
  NJD: { name: 'Devils', fullName: 'New Jersey Devils', abbr: 'NJ', logo: `${TEAM_LOGO_BASE}/NJD.png` },
  SJS: { name: 'Sharks', fullName: 'San Jose Sharks', abbr: 'SJ', logo: `${TEAM_LOGO_BASE}/SJS.png` },
  TBL: { name: 'Lightning', fullName: 'Tampa Bay Lightning', abbr: 'TB', logo: `${TEAM_LOGO_BASE}/TBL.png` },
  VEG: { name: 'Golden Knights', fullName: 'Vegas Golden Knights', abbr: 'VGK', logo: `${TEAM_LOGO_BASE}/VGKG.png` },
  WAS: { name: 'Capitals', fullName: 'Washington Capitals', abbr: 'WSH', logo: `${TEAM_LOGO_BASE}/WASC.png` },
  WIN: { name: 'Jets', fullName: 'Winnipeg Jets', abbr: 'WPG', logo: `${TEAM_LOGO_BASE}/WPGJ.png` },
};

export function getNhlTeamInfo(abbr: string): TeamInfo {
  return nhlTeams[abbr.toUpperCase()] || {
    name: abbr,
    fullName: abbr,
    abbr: abbr,
    logo: '',
  };
}

// Derive full name to abbreviation mapping from nhlTeams
// Also includes common alternate names (LA Kings, St Louis Blues without period)
export const NHL_TEAM_NAME_TO_ABBR: Record<string, string> = Object.values(nhlTeams)
  .filter((team, index, self) => self.findIndex(t => t.abbr === team.abbr) === index) // dedupe by abbr
  .reduce((acc, team) => {
    acc[team.fullName] = team.abbr;
    // Add LA variant for Los Angeles Kings
    if (team.fullName.startsWith('Los Angeles')) {
      acc[team.fullName.replace('Los Angeles', 'LA')] = team.abbr;
    }
    // Add St Louis variant without period
    if (team.fullName.includes('St.')) {
      acc[team.fullName.replace('St.', 'St')] = team.abbr;
    }
    return acc;
  }, {} as Record<string, string>);
